/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Detail_ReviewsInputs */

const en_directory_detail_reviews = /** @type {(inputs: Directory_Detail_ReviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reviews (${i?.count})`)
};

const zh_directory_detail_reviews = /** @type {(inputs: Directory_Detail_ReviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`评价 (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Reviews ({count})" |
*
* @param {Directory_Detail_ReviewsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_reviews = /** @type {((inputs: Directory_Detail_ReviewsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_ReviewsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_reviews(inputs)
	return zh_directory_detail_reviews(inputs)
});
export { directory_detail_reviews as "directory.detail.reviews" }